/**
 * Background layers are the comma-separated entries of `background-image`, `background-size`,
 * `background-position` and `background-repeat`. The first layer paints on top; when lists differ in length,
 * CSS repeats the shorter list from its start.
 */

/** Splits a CSS list at top-level commas, keeping commas inside `linear-gradient(…)`, `var(…)` or `url(…)`. */
export function splitBackgroundLayers(value: string | undefined): string[] {
	if (!value?.trim()) return [];
	const layers: string[] = [];
	let depth = 0;
	let quote = '';
	let current = '';
	for (const char of value) {
		if (quote) {
			if (char === quote) quote = '';
		} else if (char === '"' || char === "'") quote = char;
		else if (char === '(') depth += 1;
		else if (char === ')') depth = Math.max(0, depth - 1);
		else if (char === ',' && depth === 0) {
			layers.push(current.trim());
			current = '';
			continue;
		}
		current += char;
	}
	layers.push(current.trim());
	return layers.filter(Boolean);
}

export function joinBackgroundLayers(layers: string[]): string {
	return layers.join(', ');
}

/** The value CSS applies to layer `index` of a list that may be shorter than the image list. */
export function getCyclicLayerValue(values: string[], index: number, fallback: string): string {
	return values.length ? values[index % values.length]! : fallback;
}
